import React from 'react';
import { Box } from '@mui/material';

const HorizontalSeparator = ({
  color = '#000',
  height = '1px',
  id,
  isSuccess,
}) => (
  <Box
    id={id}
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      mt: isSuccess ? 2 : 1,
      mb: isSuccess ? 2 : 1,
    }}
  >
    <Box
      sx={{
        height,
        backgroundColor: color,
        width: '100%',
      }}
    />
  </Box>
);

export default HorizontalSeparator;
